module.exports = __webpack_public_path__ + "img/24.a3c73f4a.svg";